







































































/* eslint-disable */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import Moment from 'moment'
import Timezone from 'moment-timezone'
import { NumberMixin, DashboardMixin } from '@finx/web-repository/src/mixin/_'

@Component({
  mixins: [NumberMixin, DashboardMixin],
})

export default class ComponentDashboardFontePagadora extends Vue {
  @Prop(Boolean) exibirValores
  @Prop(Date) dataSelecionada
  @Prop(Array) dataset
  @Prop(String) mounthSelected
  @Prop(String) yearSelected

  get runningCoords() {
    let start: any = this.nominalStart
    let i
    let total = 0

    for (i in this.fontePagadoraDoughutItems) total += this.fontePagadoraDoughutItems[i].valor

    return this.fontePagadoraDoughutItems.map((slice) => {
      const _return = start
      start += (slice.valor / total)
      return _return
    })
  }

  get mesSelecionado() {
    return Moment(this.dataSelecionada).locale('pt-br').format('MMM')
  }

  get anoSelecionado() {
    return Moment(this.dataSelecionada).locale('pt-br').format('YYYY')
  }

  cor(index) {
    switch (parseInt(index)) {
      case 0:
        return '#03a5ed'
      case 1:
        return '#2652a3'
      case 2:
        return '#3ee9ff'
      case 3:
        return '#5b88da'
      case 4:
        return '#0e7dae'
      default:
        return '#03a5ed'
    }
  }

  radius: Number = 1
  nominalStart: Number = 0
  fontePagadoraDoughutItems: any[] = []

  @Watch('dataset')
  onDatasetChange(newArray) {
    this.fontePagadoraDoughutItems = []
    // @ts-ignore
    for (let i = 0; i < this.dataset.length; i++) {

      let temp = {
        identificador: this.dataset[i].identificador,
        nome: this.dataset[i].nome,
        porcentagem: this.dataset[i].porcentagem,
        valor: this.dataset[i].valor,
      }

      if (i < 4) {
        this.fontePagadoraDoughutItems.push(temp)
      } else {

        this.fontePagadoraDoughutItems[3].porcentagem += this.dataset[i].porcentagem
        this.fontePagadoraDoughutItems[3].nome = 'Outros'
        this.fontePagadoraDoughutItems[3].valor += this.dataset[i].valor
      }
    }
  }

  created() {
    this.nominalStart = 0
  }

  formatarPorcentagem(value) {
    return _.round(value, 0)
  }

  drawSection(slice, index) {
    let i
    let
      total = 0
    for (i in this.fontePagadoraDoughutItems) total += this.fontePagadoraDoughutItems[i].valor

    const {
      radius
    } = this
    const start = this.getCoordinatesForPercent(this.runningCoords[index],
      radius)
    const end = this.getCoordinatesForPercent(this.runningCoords[index] + (
      slice.valor / total), radius)
    const largeArcFlag = (slice.valor / total) > 0.5 ? 1 : 0

    return [
      `M ${start.join(' ')}`, // Move
      `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${end.join(' ')}`, // Arc
      'L 0 0', // Line
    ].join(' ')
  }

  getCoordinatesForPercent(pct, radius) {
    const x = radius * Math.cos(2 * Math.PI * pct)
    const y = radius * Math.sin(2 * Math.PI * pct)
    return [x, y]
  }

  @Watch('dataSelecionada')
  onDataSelecionadaChanged(newValue) {
  }
}

